import React from "react";
import styled from "styled-components";

export const StyledCellText = styled("div")`
    padding: 0 1em;

    .disabled {
        margin-left: -0.8em;
    }
`;

const CellText = ({ title, value }: { title?: string; value: string | number }) => {
    return <StyledCellText title={title}>{value}</StyledCellText>;
};

export default CellText;
